import { QrCode } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function QRCodeEmptyState() {
  const { t } = useTranslation()

  return (
    <div className='flex flex-col items-center justify-center pt-10'>
      <div className='w-full max-w-lg p-10 rounded-2xl text-center transition-all duration-300 bg-white'>
        <QrCode className='h-24 w-24 mx-auto mb-4 text-gray-400' />
        <h2 className='text-lg font-bold text-[#181D27]'>
          {t('qrCode.noQRCodes')}
        </h2>
        <p className='text-sm text-[#414651] mt-4'>
          {t('qrCode.noQRCodesDescription')}
        </p>
      </div>
    </div>
  )
}
